import React from 'react'
import { SanityHeading } from '../../../../../types/generated/graphql-types'
import { BlockWithId } from '../../../../utilities/blockId'
import { PageHeader } from '../../../blocks/PageHeader'

export type HeadingSerializerProps = SanityHeading & BlockWithId

export const HeadingSerializer = ({ id, ...props }: HeadingSerializerProps) => (
  <div className="my-60 sm:my-90 lg:my-120" id={id}>
    <PageHeader
      heading={props.heading ?? undefined}
      preamble={props.preamble ?? undefined}
      subheading={props.subheading ?? undefined}
    />
  </div>
)
